import api from '../config/api';

const planillaService = {
  // Obtener planillas por empresa (usando la ruta correcta del backend)
  obtenerPlanillasPorEmpresa: async (empresaId) => {
    try {
      const response = await api.get(`/planillas/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener planillas por empresa:', error);
      throw error;
    }
  },

  // Obtener todas las planillas con filtros (método legacy)
  obtenerPlanillas: async (filtros = {}) => {
    try {
      // Si se especifica empresa_id, usar el método específico
      if (filtros.empresa_id && Object.keys(filtros).length === 1) {
        return await this.obtenerPlanillasPorEmpresa(filtros.empresa_id);
      }
      
      const params = new URLSearchParams();
      
      if (filtros.empresa_id) {
        params.append('empresa_id', filtros.empresa_id);
      }
      if (filtros.estado) {
        params.append('estado', filtros.estado);
      }
      if (filtros.fecha_inicio) {
        params.append('fecha_inicio', filtros.fecha_inicio);
      }
      if (filtros.fecha_fin) {
        params.append('fecha_fin', filtros.fecha_fin);
      }
      if (filtros.periodo) {
        params.append('periodo', filtros.periodo);
      }

      const response = await api.get(`/planillas?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener planillas:', error);
      throw error;
    }
  },

  // Obtener una planilla específica
  obtenerPlanilla: async (planillaId) => {
    try {
      const response = await api.get(`/planillas/${planillaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener planilla:', error);
      throw error;
    }
  },

  // Crear una nueva planilla
  crearPlanilla: async (datosplanilla) => {
    try {
      const response = await api.post('/planillas', datosplanilla);
      return response.data;
    } catch (error) {
      console.error('Error al crear planilla:', error);
      throw error;
    }
  },

  // Actualizar una planilla existente
  actualizarPlanilla: async (planillaId, datosActualizacion) => {
    try {
      const response = await api.put(`/planillas/${planillaId}`, datosActualizacion);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar planilla:', error);
      throw error;
    }
  },

  // Cerrar planilla (cambiar estado a cerrado)
  cerrarPlanilla: async (id, comentarios = '') => {
    try {
      const response = await api.put(`/planillas/${id}/cerrar`, {
        comentarios: comentarios
      });
      return response.data;
    } catch (error) {
      console.error('Error al cerrar planilla:', error);
      throw error;
    }
  },

  // Reabrir planilla (cambiar estado a proceso)
  reabrirPlanilla: async (id, comentarios = '') => {
    try {
      const response = await api.put(`/planillas/${id}/reabrir`, {
        comentarios: comentarios
      });
      return response.data;
    } catch (error) {
      console.error('Error al reabrir planilla:', error);
      throw error;
    }
  },

  // Eliminar una planilla
  eliminarPlanilla: async (planillaId) => {
    try {
      const response = await api.delete(`/planillas/${planillaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar planilla:', error);
      throw error;
    }
  },

  // Obtener empleados de una planilla con sus conceptos
  obtenerEmpleadosPlanilla: async (planillaId) => {
    try {
      const response = await api.get(`/planillas/${planillaId}/empleados`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener empleados de planilla:', error);
      throw error;
    }
  },

  // Obtener conceptos agrupados de una planilla
  obtenerConceptosPlanilla: async (planillaId) => {
    try {
      const response = await api.get(`/planillas/${planillaId}/conceptos`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener conceptos de planilla:', error);
      throw error;
    }
  },

  // Obtener códigos PLAME de una planilla
  obtenerCodigosPlame: async (planillaId) => {
    try {
      const response = await api.get(`/planillas/${planillaId}/plame`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener códigos PLAME:', error);
      throw error;
    }
  },

  // Exportar planilla a formato PLAME
  exportarPlame: async (planillaId, formato = 'txt') => {
    try {
      const response = await api.get(`/planillas/${planillaId}/exportar-plame`, {
        params: { formato },
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error al exportar PLAME:', error);
      throw error;
    }
  },

  // Exportar planilla a PDF
  exportarPdf: async (planillaId) => {
    try {
      const response = await api.get(`/planillas/${planillaId}/exportar-pdf`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error al exportar PDF:', error);
      throw error;
    }
  },

  // Exportar planilla a Excel
  exportarExcel: async (planillaId) => {
    try {
      const response = await api.get(`/planillas/${planillaId}/exportar-excel`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error al exportar Excel:', error);
      throw error;
    }
  },

  // Obtener resumen de planilla
  obtenerResumenPlanilla: async (planillaId) => {
    try {
      const response = await api.get(`/planillas/${planillaId}/resumen`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener resumen de planilla:', error);
      throw error;
    }
  },

  // Procesar planilla (generar conceptos automáticamente)
  procesarPlanilla: async (planillaId) => {
    try {
      const response = await api.post(`/planillas/${planillaId}/procesar`);
      return response.data;
    } catch (error) {
      console.error('Error al procesar planilla:', error);
      throw error;
    }
  },

  // Validar planilla antes de cerrar
  validarPlanilla: async (planillaId) => {
    try {
      const response = await api.post(`/planillas/${planillaId}/validar`);
      return response.data;
    } catch (error) {
      console.error('Error al validar planilla:', error);
      throw error;
    }
  },

  // Obtener estadísticas de planillas
  obtenerEstadisticas: async (empresaId) => {
    try {
      const response = await api.get(`/planillas/estadisticas/${empresaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener estadísticas:', error);
      throw error;
    }
  },

  // Obtener períodos disponibles
  obtenerPeriodos: async (empresa_id = 1) => {
    try {
      const response = await api.get(`/planillas/periodos?empresa_id=${empresa_id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener períodos:', error);
      throw error;
    }
  },

  // Duplicar planilla
  duplicarPlanilla: async (planillaId, nuevosDatos) => {
    try {
      const response = await api.post(`/planillas/${planillaId}/duplicar`, nuevosDatos);
      return response.data;
    } catch (error) {
      console.error('Error al duplicar planilla:', error);
      throw error;
    }
  },

  // Obtener historial de cambios de una planilla
  obtenerHistorial: async (planillaId) => {
    try {
      const response = await api.get(`/planillas/${planillaId}/historial`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener historial:', error);
      throw error;
    }
  },

  // Obtener todas las planillas de una empresa
  obtenerPlanillasPorEmpresa: async (empresaId) => {
    try {
      const response = await api.get(`/planillas/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener planillas:', error);
      throw error;
    }
  },

  // Obtener opciones para formularios (estados y modalidades)
  obtenerOpciones: async () => {
    try {
      const response = await api.get('/planillas/opciones');
      return response.data;
    } catch (error) {
      console.error('Error al obtener opciones:', error);
      throw error;
    }
  },

  // Validar nombre de planilla (formato YYYY-MM)
  validarNombrePlanilla: (nombre) => {
    const regex = /^\d{4}-\d{2}$/;
    return regex.test(nombre);
  },

  // Generar nombre de planilla basado en fecha
  generarNombrePlanilla: (fecha = new Date()) => {
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  },

  // Formatear fecha para mostrar
  formatearFecha: (fecha) => {
    if (!fecha) return '';
    
    // Manejar como string para evitar problemas de zona horaria
    if (typeof fecha === 'string') {
      // Extraer solo la parte de la fecha (YYYY-MM-DD) del timestamp
      const fechaSolo = fecha.split('T')[0]; // "2025-06-30T00:00:00.000000Z" -> "2025-06-30"
      
      if (fechaSolo.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = fechaSolo.split('-');
        return `${day}/${month}/${year}`;
      }
    }
    
    // Para otros formatos, usar el método anterior
    const fechaObj = new Date(fecha);
    return fechaObj.toLocaleDateString('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  },

  // Formatear periodo completo
  formatearPeriodo: (fechaInicio, fechaFin) => {
    if (!fechaInicio || !fechaFin) return '';
    return `${planillaService.formatearFecha(fechaInicio)} - ${planillaService.formatearFecha(fechaFin)}`;
  },

  // Obtener color del estado
  obtenerColorEstado: (estado) => {
    const colores = {
      'proceso': 'blue',
      'cerrada': 'green',
      'anulada': 'red'
    };
    return colores[estado] || 'gray';
  },

  // Obtener color de la modalidad
  obtenerColorModalidad: (modalidad) => {
    const colores = {
      'planilla_normal': 'blue',
      'planilla_rh': 'purple',
      'planilla_mixta': 'orange',
      'planilla_construccion': 'amber',
      'planilla_jornales': 'emerald'
    };
    return colores[modalidad] || 'gray';
  },

  // Verificar si una planilla puede ser editada
  puedeSerEditada: (planilla) => {
    return planilla && planilla.estado === 'proceso';
  },

  // Verificar si una planilla puede ser cerrada
  puedeSerCerrada: (planilla) => {
    return planilla && planilla.estado === 'proceso';
  },

  // Verificar si una planilla puede ser anulada
  puedeSerAnulada: (planilla) => {
    return planilla && ['proceso', 'cerrada'].includes(planilla.estado);
  },

  // Obtener descripción del estado
  obtenerDescripcionEstado: (estado) => {
    const descripciones = {
      'proceso': 'En Proceso',
      'cerrada': 'Cerrada',
      'anulada': 'Anulada'
    };
    return descripciones[estado] || estado;
  },

  // Obtener descripción de la modalidad
  obtenerDescripcionModalidad: (modalidad) => {
    const descripciones = {
      'planilla_normal': 'Planilla Normal',
      'planilla_rh': 'Planilla RH',
      'planilla_mixta': 'Planilla Mixta',
      'planilla_construccion': 'Planilla Construcción Civil',
      'planilla_jornales': 'Planilla de Jornales'
    };
    return descripciones[modalidad] || modalidad;
  },

  // Calcular duración del periodo en días
  calcularDuracionPeriodo: (fechaInicio, fechaFin) => {
    if (!fechaInicio || !fechaFin) return 0;
    const inicio = new Date(fechaInicio);
    const fin = new Date(fechaFin);
    const diferencia = fin.getTime() - inicio.getTime();
    return Math.ceil(diferencia / (1000 * 3600 * 24)) + 1;
  },

  // Validar fechas del periodo
  validarPeriodo: (fechaInicio, fechaFin) => {
    if (!fechaInicio || !fechaFin) {
      return { valido: false, mensaje: 'Ambas fechas son requeridas' };
    }

    const inicio = new Date(fechaInicio);
    const fin = new Date(fechaFin);

    if (fin < inicio) {
      return { valido: false, mensaje: 'La fecha fin debe ser igual o posterior a la fecha inicio' };
    }

    return { valido: true };
  },

  // Cambiar el estado de una planilla
  cambiarEstado: async (planillaId, nuevoEstado, comentario = null) => {
    try {
      const response = await api.put(`/planillas/${planillaId}/estado`, {
        estado: nuevoEstado,
        comentario: comentario
      });
      return response.data;
    } catch (error) {
      console.error('Error al cambiar estado de planilla:', error);
      throw error;
    }
  }
};

export default planillaService; 